import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LandingPageVideoComponent } from '../landing-page-video/landing-page-video.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';

import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { ViewLandingPageVideoComponent } from '../view-landing-page-video/view-landing-page-video.component';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
export interface Video {
  srNo: number;
  title: string;
  description: string;
  attachment?: string;
}

@Component({
  selector: 'app-view-landing-page-video-table',
  templateUrl: './view-landing-page-video-table.component.html',
  styleUrls: ['./view-landing-page-video-table.component.scss'],
})

export class ViewLandingPageVideoTableComponent implements OnInit {
  displayedColumns: string[] = ['srNo', 'title', 'description', 'attachment', 'action'];
  videos: Video[] = [];
  openViewList: boolean = false;
  buttonColorName: any
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  dataSource!: MatTableDataSource<Video>;
  loggedInUserCompanyID: any;
  loggedInUserRole:any
  
  constructor(public dialog: MatDialog, private dialogRef: MatDialogRef<ViewLandingPageVideoTableComponent>, private encryptionService: EncryptionService, private httpService: HttpService, private config: Config, private toastr: ToastrService, public mobileResponsiveService: MobileResponsiveService) { }

  ngOnInit(): void {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.getData()
  }
  
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  getData() {
    this.httpService.callGetService(`${this.config.getVideos}`)
    .subscribe((res: any) => {
      
      // Assign serial numbers dynamically
      res.forEach((video: any, index: number) => {
        video.srNo = index + 1;
      });
      
      // Assign to MatTableDataSource
      this.dataSource = new MatTableDataSource(res);
      
      // ✅ Attach paginator & sort after assigning data
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }
  
  showVideo() {
    this.openViewList = true;
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '80%';
    // dialogConfig.width = '80%';
    dialogConfig.data = {
      showData: this.dataSource
    };
    // dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidth1300AndBelow;
    dialogConfig.disableClose = false;
    const dialogRef = this.dialog.open(ViewLandingPageVideoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      this.getData();
      this.openViewList = false
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  createVideo(data: any) {
    // window.open(handbookUrl, '_blank');
    // this.openViewList = true;
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '50%';
    // dialogConfig.width = '50%';
    dialogConfig.data = {
      patchData: data
    };
    // dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    dialogConfig.maxWidth = '540px';

    // dialogConfig.disableClose = false;
    const dialogRef = this.dialog.open(LandingPageVideoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      this.getData();
      this.openViewList = false
    });
    
  }
  openVideo(url: string) {
    if (url) {
      // Open in a new tab
      window.open(url, '_blank');
    } else {
      console.warn('No video URL provided for this row.');
    }
  }
  
  editVideo(video: any) {
    this.createVideo(video)
  }
  
  // deleteVideo(videoId: Video) {
  //   this.httpService.callDeleteService(`${this.config.deletevideo}/${videoId}`).subscribe({
  //     next: (data: any) => {
  
  //       const successMsg = data?.message ? data.message: "Deleted Successfully";
  //       this.toastr.success(successMsg); // 👈 Show toast
  //       this.getData()
  //     },
  //     error: (error: any) => {
  
  //       const errorMsg = error?.probationId ? " Failed to Delete" : "Failed to Delete";
  //       this.toastr.error(errorMsg);
  //       this.getData()
  //     }
  //   });
  
  
  
  // }
  
  deleteVideo(videoId: Video) {
    // Open confirmation dialog first
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete this video?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // If user confirms, call delete API
        this.httpService.callDeleteService(`${this.config.deletevideo}/${videoId}`).subscribe({
          next: (data: any) => {
            // Show success dialog
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data?.message || 'Video deleted successfully.',
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false,
              },
            });
            
            successdialogRef.afterClosed().subscribe(() => {
              this.getData(); // Refresh data after closing success dialog
            });
          },
          error: (error: any) => {
            // Optional: show error dialog
            const errDialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: 'Failed to delete video.',
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false,
              },
            });
          }
        });
      }
    });
  }
  
  onClose() {
    this.dialogRef.close();
  }
}
